import { AccountComponent } from './account/account.component';
import { AccountDialogComponent } from './account/account-edit-dialog/account-dialog.component';
import { AccountInnerDialogComponent } from './account/account-edit-dialog/account-inner-dialoge/account-inner-dialog.component';
import { AccountManagmentComponent } from '../account-managment/account-managment.component';
import { AccountManagmentModule } from '../account-managment/account-managment.module';
import { ActivitiesComponent } from '../activities/activities.component';
import { ApplicationPipesModule } from '../application-pipes.module';
import { AuthGuard } from '../../../_guards';
import { BusinessComponent } from './business/business.component';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { CommonModule, DecimalPipe } from '@angular/common';
import { DefultsComponent } from './defaults/defaults.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { EmailConfigurationComponent } from './email-configuration/email-configuration.component';
import { EmailSignatureComponent } from './email-signature/email-signature.component';
import { EstimatesSettingComponent } from './estimates-setting/estimates-setting.component';
import { ExchangeRatesComponent } from './exchange-rates/exchange-rates.component';
import { FileDragNDropModule } from '@directives/file-drag-n-drop/file-drag-n-drop.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ImageEditorModule } from '@syncfusion/ej2-angular-image-editor';
import { InterstRatesComponent } from './interst-rates/interst-rates.component';
import { InvoiceOptionsComponent } from './templates/invoice-options/invoice-options.component';
import { InvoiceTemplatesPopupComponent } from './invoice-templates-popup/invoice-templates-popup.component';
import { LookupsComponent } from './lookups/lookups.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatterRatesComponent } from './matter-rates/matter-rates.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { MiscellaneousComponent } from './lookups/miscellaneous/miscellaneous.component';
import { NameComponent } from './name/name.component';
import { NgModule } from '@angular/core';
import { NgxCurrencyModule } from '@directives/currencymask/currency-mask.module';
import { PipesModule } from '@_pipes/pipes.module';
import { PracticeAccountDetailsComponent } from './business/practice-account-details/practice-account-details.component';
import { ReginoalSettingComponent } from './regional-setting/reginoal-setting.component';
import { ResizableModule } from 'angular-resizable-element';
import { RouterModule, Routes } from '@angular/router';
import { SearchProviderComponent } from './business/search-provider/search-provider.component';
import { SettingSidebarComponent } from './setting-sidebar/setting-sidebar.component';
import { SILQpayComponent } from './account/silqpay/silqpay.component';
import { StatementsComponent } from './templates/statements/statements.component';
import { SystemSettingComponent } from './system-setting.component';
import { SystemSettingTemplateModule } from './templates/templates.module';
import { TemplatesComponent } from './templates/templates.component';
import { TrustComponent } from './trust/trust.component';
import { UsersModule } from '../../pages/users/users.module';
import { XeroIntegrationComponent } from './account/xero-integration/xero-integration.component';
import { DateAdapter, MAT_DATE_FORMATS, MatDateFormats } from '@angular/material/core';
import { CustomDateAdapter } from 'src/app/customDate.adapter';
import { TasksPackComponent } from './workflow/tasks-pack/tasks-pack.component';
import { AddTaskPackComponent } from './workflow/add-task-pack/add-task-pack.component';
import { TemplateLayoutComponent } from './workflow/template-layout/template-layout.component';
import { TemplateModule } from '@pages/template/template.module';
import { AmlCtfSettingComponent } from './account/aml-ctf-setting/aml-ctf-setting.component';
import { MaterialModule } from 'src/app/Shared/material.module';
import { PermissionGuard } from '@/app/_guards/permission.guard';
import { APIAccessComponent } from './templates/apiaccess/apiaccess.component';
import { ApiAccessPopupComponent } from './api-access-popup/api-access-popup.component';
import { ApiSecretPopupComponent } from './api-secret-popup/api-secret-popup.component';

export const CUSTOM_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

/**
 * This is using for set the route JSON
 */
const routes: Routes = [
  {
    path: '',
    redirectTo: 'system-setting/search-provider',
    pathMatch: 'full',
    canActivate: [AuthGuard, PermissionGuard],
  },
  {
    path: '',
    component: SystemSettingComponent,
    children: [
      {
        path: 'name',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Name',
        },
      },
      {
        path: 'business',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Business',
        },
      },
      {
        path: 'defaults',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Defaults',
        },
      },
      {
        path: 'regional',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Regional',
        },
      },
      {
        path: 'trust',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Trust',
        },
      },
      {
        path: 'templates',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Templates',
        },
      },
      {
        path: 'estimates',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Estimates',
        },
      },
      {
        path: 'account',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting -  Account',
        },
      },
      {
        path: 'exchange-rates',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Exchange Rates',
        },
      },
      {
        path: 'interest-rates',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Interest Rates',
        },
      },
      {
        path: 'matter-class-rates',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Matter Class Rates',
        },
      },
      {
        path: 'SilqPay',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - SilqPay',
        },
      },
      {
        path: 'search-provider',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Search Provider',
        },
      },
      {
        path: 'xero-integration',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Xero Integration',
        },
      },
      {
        path: 'aml-ctf',
        component: SystemSettingComponent,
        data: {
          title: 'AML/CTF Settings',
        },
      },
      {
        path: 'statements',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Statements',
        },
      },
      {
        path: 'invoice-options',
        component: InvoiceOptionsComponent,
        data: {
          title: 'System Setting - Invoice Template Options',
        },
      },
      {
        path: 'lookups',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - Lookups',
        },
      },
      {
        path: 'miscellaneous',
        component: SystemSettingComponent,
        data: {
          title: 'System Setting - miscellaneous',
        },
      },
      {
        path: 'activities',
        component: ActivitiesComponent,
        data: {
          title: 'System Setting - Activities & Sundries',
        },
      },
      {
        path: 'email-signature',
        component: EmailSignatureComponent,
        data: {
          title: 'System Setting - Email Signature',
        },
      },
      {
        path: 'email-configuration',
        component: EmailConfigurationComponent,
        data: {
          title: 'System Setting - Email Configuration',
        },
      },
      {
        path: 'apiaccess',
        component: APIAccessComponent,
        data: {
          title: 'API Access',
        },
      },
      {
        path: 'account-management/basicinfo',
        component: AccountManagmentComponent,
        data: {
          title: 'Account & Management - Basicinfo',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'account-management/products',
        component: AccountManagmentComponent,
        data: {
          title: 'Account & Management - Products',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'account-management/receipts',
        component: AccountManagmentComponent,
        data: {
          title: 'Account & Management - Receipts',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'account-management/payment',
        component: AccountManagmentComponent,
        data: {
          title: 'Account & Management - Payment',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'workflow',
        component: TasksPackComponent,
        data: {
          title: 'System Settings - Workflow',
        },
        canActivate: [AuthGuard],
      },
      {
        path: 'users',
        loadChildren: () => import('../../pages/users/users.module').then((m) => m.UsersModule),
      },
      // {
      //   path: 'users', component: UsersComponent , data: {
      //     title: 'System Setting - User',
      //     children :[
      //       {
      //         path: 'useractivity', component: UsersComponent , data: {
      //           title: 'System Setting - User Activity'
      //         }
      //       }
      //     ]
      //   }
      // },
    ],
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [
    SystemSettingComponent,
    NameComponent,
    SettingSidebarComponent,
    BusinessComponent,
    DefultsComponent,
    EstimatesSettingComponent,
    ReginoalSettingComponent,
    TrustComponent,
    TemplatesComponent,
    AccountComponent,
    AccountDialogComponent,
    AccountInnerDialogComponent,
    ExchangeRatesComponent,
    InterstRatesComponent,
    MatterRatesComponent,
    XeroIntegrationComponent,
    AmlCtfSettingComponent,
    SearchProviderComponent,
    SILQpayComponent,
    StatementsComponent,
    LookupsComponent,
    MiscellaneousComponent,
    EmailSignatureComponent,
    EmailConfigurationComponent,
    InvoiceOptionsComponent,
    APIAccessComponent,
    ActivitiesComponent,
    InvoiceTemplatesPopupComponent,
    AccountManagmentComponent,
    PracticeAccountDetailsComponent,
    TasksPackComponent,
    AddTaskPackComponent,
    TemplateLayoutComponent,
    AmlCtfSettingComponent,
    ApiAccessPopupComponent,
    ApiSecretPopupComponent,
    // UsersComponent
  ],
  imports: [
    TemplateModule,
    MatDialogModule,
    ImageEditorModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SystemSettingTemplateModule,
    RouterModule.forChild(routes),
    MatTreeModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTableModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatCardModule,
    MatSelectModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    MatButtonToggleModule,
    CKEditorModule,
    MatTabsModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatCheckboxModule,
    DragDropModule,
    MatExpansionModule,
    MatRadioModule,
    MatSortModule,
    ResizableModule,
    PipesModule,
    ApplicationPipesModule,
    FileDragNDropModule,
    AccountManagmentModule,
    UsersModule,
    MatTooltipModule,
    NgxCurrencyModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MaterialModule,
  ],
  exports: [
    SystemSettingComponent,
    AccountDialogComponent,
    AccountInnerDialogComponent,
    MatTreeModule,
    InvoiceTemplatesPopupComponent,
    FileDragNDropModule,
    // UsersComponent
  ],
  bootstrap: [AccountInnerDialogComponent],
  providers: [
    DecimalPipe,
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    provideNgxMask(),
  ],
})
export class SystemSettingModule {}
